import React from "react";
import { FaLocationDot } from "react-icons/fa6";
import { assets } from "../../Assets/assets";

const TopFooter = () => {
  const branches = [
    {
      label: "Branch-2",
      address:
        "#104, 3rd main, 3rd cross, Nagendra block Srinagar, Bangalore south Karnataka 560050",
    },
    {
      label: "Head Office",
      address:
        "Odyssa Business Centre, Office # 412, 4th Floor, Nh-16, Sector A, Rasulgarh, Bhubaneswar, Odisha 751010",
    },
    {
      label: "Branch-3",
      address:
        "Jharpara, Bhubaneswar, Khordha, 751006",
    },
  ];

  return (
    <section className="w-full max-w-[1400px] mx-auto  py-10 px-6">
      <div className="space-y-10">
        <div data-aos="fade-up" data-aos-duration="1000"
          className="rounded-2xl p-10 md:p-20 bg-cover bg-center flex flex-col lg:flex-row flex-wrap justify-between gap-6 text-white shadow-xl"
          style={{ backgroundImage: `url(${assets.footerbg})` }}
        >
          <div className="text-[26px] font-semibold leading-8 tracking-wide">
            Subscribe to our <br /> Newsletter
          </div>

          <div className="flex items-center gap-3 bg-white/20 backdrop-blur-md px-4 py-2 rounded-lg border border-white/30 w-full max-w-[380px]">
            <input
              type="email"
              placeholder="Your Email"
              className="bg-transparent w-full placeholder:text-[#D9DEE8] text-white outline-none text-sm"
            />
            <button className="bg-[#00B0FF] hover:bg-[#0090d6] transition-all px-3 md:px-5 py-2 text-xs md:text-sm font-medium rounded-full text-white">
              Subscribe
            </button>
          </div>

          <p className="text-[12px] opacity-90 max-w-[320px]">
            Let's discuss IT strategy, service, and business solutions & compliance concerns.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 text-center gap-10">
          {branches.map((item, index) => (
            <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100} key={index} className="relative">
              <div className="flex justify-center mb-2">
                <span className="w-12 h-12 bg-[#EAF2FF] rounded-full flex items-center justify-center shadow-md">
                  <FaLocationDot className="text-primaryColor text-lg" />
                </span>
              </div>

              <h3 className="font-semibold text-sm mb-2 text-primaryNavyTextColor">
                {item.label}
              </h3>

              <p className="text-[13px] text-secondaryTextColor leading-5 px-4 ">
                {item.address}
              </p>

              {/* {index !== branches.length - 1 && (
                <div className="hidden sm:block absolute top-0 right-0 h-full w-[1px] bg-gray-300"></div>
              )} */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopFooter;
